import React, { Component } from 'react';
import {
  Col,
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  ModalFooter,
} from 'reactstrap';
import IntlMessage from "../../helpers/intlMessage";

class JustificativaComponent extends Component {
  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup className='justificativa-cancelar'>
                <Label>{this.props.label}</Label>
                <Input
                  type='textarea'
                  name='text'
                  placeholder={this.props.placeholder}
                  onChange={(e) => {
                    this.props.setJustificativa(e.target.value);
                  }}
                  value={this.props.justificativa}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={this.props.onClick}
            disabled={!this.props.justificativa}
            color='primary'
          >
            {this.props.btnText}
          </Button>
          <Button onClick={this.props.toggle} color='secondary'>
            <IntlMessage id="dashboards.examDetails.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default JustificativaComponent;



// WEBPACK FOOTER //
// ./src/componentes/justificativa/justificativa.component.js